module.exports = __webpack_public_path__ + "img/icon-profile.6a6a7c92.svg";